@if (isDownloadable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onDownload($event)"
    icon="cloud_download"
    size="small"></pas-button-round>
}
